module.exports = __webpack_public_path__ + "img/cxcy.22abd3f.png";